import { render, staticRenderFns } from "./VaAdvancedColorPicker.demo.vue?vue&type=template&id=5af9071e&"
import script from "./VaAdvancedColorPicker.demo.vue?vue&type=script&lang=js&"
export * from "./VaAdvancedColorPicker.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports